/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {AxiosResponse} from 'axios';
import ApiException from '@/exceptions/ApiException';
import {AbstractHttpService} from '@/services/http/abstract';

/**
 * Auth service class used to leverage http library in order to communicate with auth service.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export class AuthService extends AbstractHttpService {
    constructor() {
        super({
            accept: 'application/json',
            contentType: 'application/x-www-form-urlencoded',
            cache: false,
            baseURL: process.env.VUE_APP_AUTH || '',
        });
    }

    /**
     * Global success response handler
     *
     * @override
     *
     * @param {AxiosResponse} response
     * @returns {AxiosResponse}
     */
    public handleSuccess(response: AxiosResponse): AxiosResponse {
        // Custom response handling
        return response;
    }

    /**
     * Inheritable exception handler.
     *
     * @override
     *
     * @param {ApiException} exception
     * @return {Promise<ApiException>}
     */
    public handleException(exception: ApiException): Promise<never> {
        // Custom error handling
        return Promise.reject(exception);
    }
}
